import * as _ from 'lodash';
import {BehaviorSubject} from 'rxjs';

import {AbstractState} from './state';
import {RightMatchStateColumns} from '../../interfaces/state';
// import {isUndefined} from 'util';

export class StateRightMatch extends AbstractState {

    // Structural elements ///////////////////////////////////////////////////////////////////////
    //  TODO: Nombre de candidats

    readonly columns = ['name', 'date', 'subAccountName', 'profiler.jobTitle', 'profiler.location', 'consultant', 'departmentName'];
    readonly columnsName = {
        fr: {
            name: 'Nom',
            date: 'Date',
            subAccountName: 'Sous-compte',
            departmentName: 'Département',
            'profiler.jobTitle': 'Profil de poste',
            'profiler.location': 'Lieu',
            'consultant': 'Demandeur'
        },
        en: {
            name: 'Name',
            date: 'Date',
            subAccountName: 'Sub-account',
            departmentName: 'Department',
            'profiler.jobTitle': 'Job profile',
            'profiler.location': 'Location',
            'consultant': 'Requester'
        }
    };

    private reportFilters = {
        minimize: false
    };

    readonly filters = [
        'search',
        'rightMatchStartDate',
        'rightMatchEndDate',
        'subAccount',
        'department'
    ];

    // private listColumnsInitialConfig: Array<RightMatchStateColumns> = [
    //     {key: 'name', display: true},
    //     {key: 'date', display: true, order: 'desc'}
    // ];
    readonly listColumnsInitialConfig = [
        {key: 'name', display: true},
        {key: 'date', display: true, order: 'desc'}
    ];

    protected state: any = {
        sideBarStatus: 'recentActivities',
        lastSideBarStatus: 'recentActivities',
        reportsTabName: 'concordanceAnalysis',
        report: {},
        goTo: null,
        selectedTab: 0,
        listView: 'list',
        listSearchFilters: {},
        listColumns: this.listColumnsInitialConfig,
        informationVisibility: true,
        displayPreferences: {
            sortBy: 'personality',
            display: {
                personality: true,
                talents: true,
                cai: true,
                targetPersonalityProfile: true
            }
        }
    };

    protected store: any = {
        multi: {
            action: '',
            idType: '',
            ids: [],
            data: []
        }
    };

    // TODO: added for refactoring

    get search(): string {
        return this.listSearchFilters.search;
    }

    // MULTISELECT ///////////////////////////////////////////////////////////////////////////////

    public multiselect = [];

    // WATCHES ///////////////////////////////////////////////////////////////////////////////////

    multiselectWatch = new BehaviorSubject(null);
    multiselectWatch$ = this.multiselectWatch.asObservable();

    stateChanged = new BehaviorSubject(null);
    stateChanged$ = this.stateChanged.asObservable();

    constructor(
        private translate
    ) {
        super();
        // Initialization from sessionStorage
        for (let item in this.state) {
            if (this.state.hasOwnProperty(item)) {
                this.retrieveStore('rightMatch.' + String(item));
            }
        }
    }

    /**
     * Partition state's parameter in function of the curent URL definitions i.e. if parameter x
     * is not required on URL y, then don't emit it, else do so.
     *
     * @param url
     * @param params
     */
    protected urlProcessing(url, params) {
        return params;
    }


    /**
     * Replace old state with the new state. Perform extra operations if needed.
     *
     * @param type
     * @param param
     * @param value
     */
    protected actionPostProcessing(type, param, value = null) {
        if (type === 'optionalParams') {
            switch (param) {
            case 'listUpdate':
                this.stateChanged.next({listUpdate: true});
                return false;
            case 'itemToDisplayUpdate':
                this.stateChanged.next({itemToDisplayUpdate: true});
                return false;
            case 'setSearchFilters':
                this.stateChanged.next({setSearchFilters: true});
                return false;
            default:
                break;
            }
        }
        return true;
    }


    // GETTERS AND SETTERS /////////////////////////////////////////////////////////////

    set sideBarStatus(status) {
        this.state.sideBarStatus = status;
    }

    get sideBarStatus(): string {
        return this.state.sideBarStatus;
    }

    set lastSideBarStatus(status) {
        this.state.lastSideBarStatus = status;
    }

    get lastSideBarStatus(): string {
        return this.state.lastSideBarStatus;
    }

    set report(report) {
        this.state.report = report;
    }

    get report(): any {
        return this.state.report;
    }

    get listSearchFilters(): any {
        return this.state.listSearchFilters;
    }

    set listSearchFilters(filters) {
        this.state.listSearchFilters = filters;
    }

    get listView(): string {
        return this.state.listView;
    }

    set listView(value) {
        this.state.listView = value;
    }

    get listColumns(): any {
        return this.state.listColumns;
    }

    set listColumns(cols) {
        this.state.listColumns = cols;
    }

    set goTo(moduleName) {
        this.state.goTo = moduleName;
    }

    get goTo() {
        return this.state.goTo;
    }

    set selectedTab(selectedTab) {
        this.state.selectedTab = selectedTab;
    }

    get selectedTab() {
        return this.state.selectedTab;
    }

    get multiAction(): any {
        return this.store.multi;
    }

    set multiAction(val) {
        this.store.multi = val;
    }

    resetMultiAction() {
        this.store.multi = {
            action: '',
            idType: '',
            ids: [],
            data: []
        };
    }

    set reportsTabName(tabName) {
        this.state.reportsTabName = tabName;
    }

    get reportsTabName(): string {
        return this.state.reportsTabName;
    }

    get displayPreferences(): any {
        return this.state.displayPreferences;
    }

    set displayPreferences(preferences) {
        this.state.displayPreferences = preferences;
    }

    get tableDefinition(): any {
        this.state.listColumns = _.uniqBy(this.state.listColumns, 'key');
        let listColumnsNonTrivial = _.compact(this.state.listColumns);
        let colNum = listColumnsNonTrivial.length;
        let tableDefinition = this.listColumnsInitialConfig;
        if (colNum >= 2) {
            tableDefinition = listColumnsNonTrivial;
        }
        tableDefinition.forEach((col, index) => {
            col['title'] = this.columnsName[this.translate.currentLang][col.key];
            /** Todo use current language */
            tableDefinition[index] = col;
        });
        return tableDefinition;
    }

    get minimizeCards() {
        return this.reportFilters.minimize;
    }

    set minimizeCards(bool) {
        this.reportFilters.minimize = bool;
    }

}
